import React, { useState, useEffect } from "react";
import axios from "axios";
import baseUrl from "../../../api/universalApi";
import { useDispatch } from "react-redux";
import { FaEye } from "react-icons/fa";
import { BiLike } from "react-icons/bi";
import { FaRegCommentDots } from "react-icons/fa";
import { useSelector } from "react-redux";
import { use } from "react";
//import baseUrl from "../../../api/universalApi";

const CLIENT_ID =
  "27064908213-sar1c6pb49flaf563qregab02ndshqfa.apps.googleusercontent.com"; // Replace with your OAuth Client ID
const CLIENT_SECRET = "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";
const API_KEY = "AIzaSyAbgB90PHtmcsRuYibqmir30qt70zR6kG0"; // Replace with your YouTube API Key
const REDIRECT_URI = "http://localhost:3000";

const Youtube = ({ isBrand, profileData }) => {
  const [token, setToken] = useState(null);
  const [channelData, setChannelData] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [videos, setVideos] = useState([]);
  const user = useSelector((state) => state.auth.authData.user);
  const [time, setTime] = useState(Date.now());

  const dispatch = useDispatch();
  const TOTAL_EXPIRY_SECONDS = 604799;

  const refreshDate = new Date(user?.youtube?.refreshDate); // must be valid Date string
  const [expiresIn, setExpiresIn] = useState(() => {
    const elapsedSeconds = Math.floor(
      (Date.now() - refreshDate.getTime()) / 1000
    );
    return TOTAL_EXPIRY_SECONDS - elapsedSeconds;
  });

  // Update time every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(Date.now());
    }, 60 * 1000); // 1 minute

    return () => clearInterval(interval);
  }, []);

  // Update expiresIn every minute
  useEffect(() => {
    setExpiresIn((prev) => (prev > 0 ? prev - 60 : 0)); // decrement 60s per minute
  }, [time]);

  // Debug log
  useEffect(() => {
    const days = Math.floor(expiresIn / (24 * 3600));
    const hours = Math.floor((expiresIn % (24 * 3600)) / 3600);
    const minutes = Math.floor((expiresIn % 3600) / 60);
    const seconds = expiresIn % 60;
  }, [expiresIn]);
  useEffect(() => {
    if (profileData?.youtube) {
      setChannelData(profileData?.youtube?.chennalData);
      setAnalytics(profileData?.youtube?.Analytics);
      setVideos(profileData?.youtube?.videos);
    }
  }, [profileData?.youtube]);

  // ✅ Login & Fetch Token with Refresh Capability
  const login = () => {
    const codeClient = window.google.accounts.oauth2.initCodeClient({
      client_id: CLIENT_ID,
      scope:
        "https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly",
      redirect_uri: REDIRECT_URI,
      prompt: "consent",
      access_type: "offline",
      callback: (response) => {
        if (response.code) {
          // Send this code to your backend to exchange for access/refresh tokens
          console.log("Authorization Code:", response.code);
          // Example POST to backend
          axios
            .post(`${baseUrl}/api/youtube/google`, {
              code: response.code,
              userId: user._id,
            })
            .then((res) => {
              const data = res.data;
              dispatch({ type: "UPDATING_SUCCESS", data: data });
            })
            .catch((error) => {
              console.error("Error exchanging code for tokens:", error);
            });
        }
      },
    });

    codeClient.requestCode();
  };

  const refreshAccessToken = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/youtube/refreshToken`, {
        refreshToken: user?.youtube?.refreshToken,
        userId: user._id,
      });

      // console.log(response.data);
      dispatch({ type: "UPDATING_SUCCESS", data: response.data });
    } catch (error) {
      console.error("Error refreshing access token:", error);
    }
  };

  const handleImageClick = (videoId) => {
    const url = `https://www.youtube.com/watch?v=${videoId}`;
    window.open(url, "_blank"); // Open in a new tab
  };

  return (
    <>
      <div className=" w-full md:w-full bg-white">
        <h1>Youtube Analytics</h1>

         {profileData?.youtube &&
          (
            <div className="flex gap-2">
            <span className="py-1 px-3 rounded-full bg-[#ff006b] text-white">
              {profileData?.youtube?.chennalData?.snippet?.title}
            </span> 
              <span className="py-1 px-3 rounded-full bg-[#ff006b] text-white cursor-pointer" onClick={refreshAccessToken}>
                Refresh
              </span>
              </div>
          ) }

        {profileData?.youtube ? (
          <>
            {/* Channel Details */}
            {channelData && (
              <div className="flex md:flex-row xs:flex-col gap-4 justify-between w-full my-3">
                <StatCard
                  title="Total Subscribers"
                  value={channelData?.statistics.subscriberCount || 0}
                  change="123"
                  isPositive={true}
                />
                <StatCard
                  title="Total Views"
                  value={channelData?.statistics?.viewCount || 0}
                  
                  change="1.5%"
                  isPositive={false}
                />
                <StatCard
                  title="Total Videos"
                  value={channelData?.statistics.videoCount || 0}
                  change="20k"
                  isPositive={true}
                />
               
              </div>
            )}

          
          </>
        ) : (
          !isBrand && (
            <button
              className="px-4 py-2 bg-pink-600 text-white rounded-lg mt-2"
              onClick={login}
            >
              Connect YouTube
            </button>
          )
        )}
      </div>

      <div className="flex flex-wrap items-center gap-3">
        {analytics?.columnHeaders?.length > 0 &&
          analytics.columnHeaders.map((header, index) => (
            <span
              key={index}
              className="px-3 py-1 bg-pink-600 text-white rounded-full text-sm"
            >
              {header.name}: {analytics.rows[0][index]}
            </span>
          ))}
      </div>

      <div className="flex flex-col w-full mt-2">
        <div className="w-full bg-white p-4 ">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Video Performance</h2>
          </div>
          <div className="w-full">
            <table className="w-full text-xs sm:text-sm text-left">
              <thead className="border-b text-gray-500">
                <tr>
                  <th className="px-2 sm:px-4 py-2">Thumbnail</th>
                  <th className="px-2 sm:px-4 py-2">Title & Date</th>
                  <th className="px-2 sm:px-4 py-2">Views</th>
                  <th className="px-2 sm:px-4 py-2">Likes</th>
                  <th className="px-2 sm:px-4 py-2">Comments</th>
                </tr>
              </thead>
              <tbody>
                {videos &&
                  videos.map((item) => (
                    <tr key={item.id} className="border-b hover:bg-gray-50">
                      <td className="px-2 sm:px-4 py-2">
                        <img
                          src={item.snippet.thumbnails.high.url}
                          alt="thumbnail"
                          className="w-12 h-12 sm:w-14 sm:h-14 rounded object-cover cursor-pointer"
                          onClick={() => handleImageClick(item.id)}
                        />
                      </td>
                      <td className="px-2 sm:px-4 py-2 max-w-[120px] sm:max-w-xs truncate">
                        <p className="mb-0 ">{item.snippet.title}</p>
                        <p className="mb-0 text-gray-500 text-xs">
                          {new Date(
                            item.snippet.publishedAt
                          ).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </p>
                      </td>
                      <td className="px-2 sm:px-4 py-2">
                        {item?.statistics?.viewCount}
                      </td>
                      <td className="px-2 sm:px-4 py-2">
                        {item?.statistics?.likeCount}
                      </td>
                      <td className="px-2 sm:px-4 py-2">
                        {item?.statistics?.commentCount}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const StatCard = ({ title, value, change, isPositive }) => (
  <div className="bg-white p-4 rounded-2xl border-2 border-gray-300 w-full text-gray-800">
    <p className="text-sm mb-1 text-gray-500">{title}</p>
    <p className="text-2xl font-bold mb-0">{value}</p>
  </div>
);

export default Youtube;
